export default __webpack_public_path__ + "static/media/Snd_ClowerC.ebced51d.mp3";